export default __webpack_public_path__ + "static/media/auth_service_google.6e281661.svg";